import { motion } from "framer-motion";
import { useLang } from "@/i18n";

export default function Manifesto() {
  const { t } = useLang();
  const chapters = t.manifesto.chapters.map((c, i) => ({ ...c, n: `0${i + 1}` }));

  return (
    <section id="manifesto" className="relative py-28 md:py-40 bg-[#050505]" data-testid="manifesto-section">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="mb-20 max-w-2xl">
          <span className="text-[#d4af37] uppercase tracking-[0.3em] text-xs flex items-center gap-3">
            <span className="h-px w-10 bg-[#d4af37]" /> {t.manifesto.eyebrow}
          </span>
          <h2 className="mt-5 font-serif-lux font-light text-4xl sm:text-6xl tracking-tight text-white">
            {t.manifesto.titleA} <span className="italic text-[#d4af37]">{t.manifesto.titleB}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#d4af37]/15 border border-[#d4af37]/15">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-[#050505] p-9 md:p-11 hover:bg-[#0d0d0d] transition-colors duration-500"
              data-testid={`manifesto-chapter-${i}`}
            >
              <span className="font-serif-lux text-6xl md:text-7xl text-stroke-gold group-hover:text-[#d4af37] transition-colors duration-500">
                {c.n}
              </span>
              <h3 className="mt-6 font-serif-lux font-light text-2xl md:text-3xl text-white">{c.title}</h3>
              <p className="mt-4 text-white/60 font-light leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
